.AmountContainer
    position: relative
    display: flex
    flex-direction: row
    align-items: center
    box-sizing: border-box
    border: 1px solid rgb($globalSettingsStrokeSecondary)
    border-radius: $globalButtonRounding
    background: rgb($globalSettingsBackgroundPrimary)
    overflow: hidden
    box-shadow: $globalButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor,0.05)
    .AmountButton
        height: 100%
        display: flex
        justify-content: center
        align-items: center
        cursor: pointer
        overflow: hidden
        stroke: rgb($globalSettingsFontSecondary)
        border-radius: $globalButtonRounding
        &:active
            padding-top: 1px
            outline: none
    .ControlContainer
        display: flex
        flex-direction: row
        height: 100%
    .Remove
        stroke: rgb($globalErrorBackground)
    .Disabled
        cursor: default
        stroke: rgb($globalSettingsFontTertiary)
        background: rgb($globalSettingsBackgroundTertiary)
        &:active
            padding-top: 0
            background: rgb($globalSettingsBackgroundTertiary)
        &:hover
            background: rgb($globalSettingsBackgroundTertiary)
    .Waved
        &:hover
            background: rgb($globalSettingsBackgroundSecondary)
        &:active
            background: rgb($globalSettingsBackgroundPrimary)
            transition: background 0s
    .AmountInput
        color: rgb($globalSettingsFontPrimary)
        background: rgb($globalSettingsBackgroundPrimary)
        border-radius: $globalButtonRounding
        font-size: 14px
        text-align: center
        box-sizing: border-box
        outline: none
        border: none
        &:focus
            outline: none
            background: rgb($globalSettingsBackgroundSecondary)
        &:hover
            background: rgb($globalSettingsBackgroundSecondary)
        &:disabled
            background: rgb($globalSettingsBackgroundTertiary)
            &:focus
                outline: none
                background: rgb($globalSettingsBackgroundTertiary)
            &:hover
                background: rgb($globalSettingsBackgroundTertiary)
    .AmountWaiting
        position: absolute
        top: 0
        bottom: 0
        left: 0
        right: 0
        background: rgb($globalSettingsBackgroundSecondary)
        opacity: 0.5
        cursor: wait
.NotAvailableContainer
    border: none
    box-shadow: none

.SearchAmountContainer // for now same as the cart style, can change in the future
    height: 24px
    .AmountButton
        width: 19px
        border-radius: 0
        svg
            transform: scale(0.8, 0.8)
    .Divider
        border-right: 1px solid rgb($globalSettingsStrokeSecondary)
        height: 100%
    .AmountInput
        width: 29px
        height: 100%
        border-radius: 0
    .DeleteButton
        width: 22px
        stroke: rgb($globalErrorBackground)
